const localeMapping = {
  en: { defaultLearningLanguage: 'SPA', displayLanguage: 'ENG', localeCountryCode: 'en', subdomain: 'www' },
  en_GB: { defaultLearningLanguage: 'FRA', displayLanguage: 'ENG', localeCountryCode: 'uk', subdomain: 'uk' },
  de: { defaultLearningLanguage: 'ENG', displayLanguage: 'DEU', localeCountryCode: 'de', subdomain: 'de' },
  fr: { defaultLearningLanguage: 'ENG', displayLanguage: 'FRA', localeCountryCode: 'fr', subdomain: 'fr' },
  it: { defaultLearningLanguage: 'ENG', displayLanguage: 'ITA', localeCountryCode: 'it', subdomain: 'it' },
  es: { defaultLearningLanguage: 'ENG', displayLanguage: 'SPA', localeCountryCode: 'es', subdomain: 'es' },
  pt: { defaultLearningLanguage: 'ENG', displayLanguage: 'POR', localeCountryCode: 'pt', subdomain: 'pt' },
  pl: { defaultLearningLanguage: 'ENG', displayLanguage: 'POL', localeCountryCode: 'pl', subdomain: 'pl' },
  sv: { defaultLearningLanguage: 'ENG', displayLanguage: 'SWE', localeCountryCode: 'se', subdomain: 'se' }
};

const languageNameMapping = {
  en: 'italian-drop-down-menu',
  en_GB: 'Italian',
  de: 'Italienisch',
  fr: 'Italien',
  it: 'Italiano',
  es: 'Italiano',
  pl: 'włoski',
  pt: 'Italiano',
  sv: 'Italienska'
};

export const getDefaultLearningLanguage = (locale) =>
  localeMapping[locale] && localeMapping[locale].defaultLearningLanguage;

export const getLanguageNameMapping = (locale) =>
  languageNameMapping[locale];

export const getLocaleData = (locale) =>
  Object.assign({ locale }, localeMapping[locale]);
